
function setCookie(cname, cvalue, hours) {
  var d = new Date();
  d.setTime(d.getTime() + (hours * 60*60*1000));

  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



// Cookies select popup
function initCookiesPopup(){
  let cookies_form = $('.js-choose-cookies-form')
  let show_cookies_popup = false

  if (getCookie('cookie_essential') ) show_cookies_popup = true;

  // Set checked cookies
  if (getCookie('cookie_marketing') ){
    $(".js-cookie-marketing").attr("checked",true);
  } else {
    $('body').addClass('no-marketing');
  }
  if (getCookie('cookie_analytical') ){
    $(".js-cookie-analytical").attr("checked",true);
  } else{
    $('body').addClass('no-analytical');
  }


  if(!show_cookies_popup) {
    $('body').addClass("js-show-cookies-popup");
  }


  // submit button click
  $(document).on("click tap",".js-submit-cookies-button", function(e) {
    let me = $(this)

    if (me.hasClass("js-allow-all-cookies")){ // allow all cookies
      cookies_form.find("input").each(function() {
        $(this).prop("checked", true)
      })

      setTimeout(function() {
        cookies_form.submit();
      },300)


    } else if (me.hasClass("js-edit-cookies")){ // edit cookies
      me.removeClass("js-edit-cookies");
      me.addClass("js-save-cookies")
      me.text(me.data("text-save-cookies"))
      cookies_form.stop().fadeIn("fast");

    } else if (me.hasClass('js-save-cookies')){ // save cookies
      cookies_form.submit();
    }

    return false;
  });


  // submit form
  cookies_form.on("submit", function (e) {
    let data = $(this).serializeArray();

    // set empty if not checked
    setCookie('cookie_analytical', '', 32)
    setCookie('cookie_marketing', '', 32)

    $.each(data, function () {
      setCookie(this.name, this.value, 32)
    });

    // hide popup
    $('body').removeClass("js-show-cookies-popup");

    return false;
  });


  // open cookies popup
  $(document).on("click tap",".js-open-cookies-settings", function() {
    $('body').addClass("js-show-cookies-popup");
    return false;
  });

}

$(document).ready(function (){
  initCookiesPopup()
})




export { setCookie, getCookie }
